/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/**
 * Component.
 */
@Component({
  name: 'survey-done-scene'
})
export default class extends Vue {
  /**
   * Property `clientName`;
   */
  @Prop({ default: null })
  clientName: string;

  /**
   * Getter `sentence`.
   */
  get sentence() {
    const { clientName: name } = this || {};

    return this.i18n('SURVEY.SENTENCES.THANKS', { data: { name } });
  }

  /**
   * Lifecycle created hook.
   */
  created() {
    const { clientName } = this || {};
    const { key } = this.$route?.params || {};

    if (!clientName) {
      this.$router.push({
        name: 'SurveyStep1',
        params: { key }
      });
    }
  }
}
